import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  ComponentModalConfig,
  ModalSize,
  SuiModal,
} from '@richardlt/ng2-semantic-ui';
import { AlertsService } from '../../../components/application-security/services/alerts.service';
import { AppFilter } from '@app/shared/models';
import { NotificationService } from 'src/modules/features/notification/services';
import { SettingsService } from '../../../components/application-security/services/settings.service';
import { variable } from '@angular/compiler/src/output/output_ast';
import { tr } from 'date-fns/locale';

interface ICreateAlertModalContext {
  title: string;
  data: any;
}

@Component({
  selector: 'app-create-alert-modal',
  templateUrl: './create-alert-modal.component.html',
  styleUrls: ['./create-alert-modal.component.scss'],
})
export class CreateAlertModalComponent implements OnInit {
  pending: boolean = false;
  users: any[] = [];
  alertScenarios: any[] = [];
  createAlertForm: FormGroup = this.fb.group({
    alertScenario: ['', Validators.required],
    variableSelected: ['', Validators.required],
    variableInput: [{ value: '', disabled: true }],
    timeframe: ['', Validators.required],
    minimumCount: ['', Validators.required],
    description: ['', Validators.required],
  });
  formSubmitAttempt: boolean;
  error: string;
  success: string;

  acceptUserId = true;
  checked = true;

  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<ICreateAlertModalContext, string, void>,
    private alertSvc: AlertsService,
    private notificationSvc: SettingsService
  ) {
    if (this.modal.context.data?.operation === 'edit') {
      this.createAlertForm.patchValue({
        timeframe: JSON.parse(this.modal.context.data?.configuration).timeframe,
        minimumCount: JSON.parse(this.modal.context.data?.configuration)
          .minimumCount,
        description: this.modal.context.data.description,
      });
    }
    if (this.modal.context.data.location == 'all-users') {
      this.createAlertForm.patchValue({
        variableInput: this.modal.context.data.payload,
      });
      // console.log('yes', this.modal.context.data.payload);
    }
  }

  filter = new AppFilter({ sidx: 'alertScenarioName' });
  notificationPreferencesFilter = new AppFilter({ rows: 1000 });

  displaySlackPreferences = false;
  displayEmailPreferences = false;

  notificationPreferenceClick(event, preferenceType: string) {
    if (preferenceType === 'slack') {
      if (this.createAlertForm.get('slack')) {
        this.displaySlackPreferences = false;
        this.createAlertForm.removeControl('slack');
      } else {
        this.displaySlackPreferences = true;
        this.createAlertForm.addControl('slack', new FormControl([]));
      }
    } else if (preferenceType === 'email') {
      if (this.createAlertForm.get('email')) {
        this.displayEmailPreferences = false;
        this.createAlertForm.removeControl('email');
      } else {
        this.displayEmailPreferences = true;
        this.createAlertForm.addControl('email', new FormControl([]));
      }
    }
  }

  notificationPreferenceChildClick(preferenceType: string, value: string) {
    if (preferenceType === 'slack') {
      this.createAlertForm.patchValue({
        slack: [...this.createAlertForm.value.slack, value],
      });
    } else if (preferenceType === 'email') {
      this.createAlertForm.patchValue({
        email: [...this.createAlertForm.value.email, value],
      });
    }
  }

  create() {
    // console.log(this.createAlertForm.value);
  }

  ngOnInit(): void {
    this.getChannel(1);
    this.getAlertScenarios();
    this.getUsersOnEservices();
    this.getNotificationPreferences();

    setTimeout(() => {
      if (this.pending) {
        this.pending = false;
        this.notificationPreferencesLoading = false;
        this.usersLoading = false;
        this.scenariosLoading = false;
        this.error = 'Loading timed out. Please try again.';
      }
    }, 10000);
    // this.document.body.classList.remove('panel');

    this.createAlertForm.valueChanges.subscribe((changes) => {
      if (changes.alertScenario !== '') {
        if (
          (changes.alertScenario &&
            changes.alertScenario === 'failed_login_attempts') ||
          changes.alertScenario === 'geofence_violations' ||
          changes.alertScenario === 'rate_limit_exceeded'
        ) {
          this.acceptUserId = true;
        } else {
          this.acceptUserId = false;
        }
      }

      if (changes?.timeframe) {
        if (!isNaN(Number(changes.timeframe))) {
          if (changes.timeframe < 1) {
            this.createAlertForm.patchValue({
              timeframe: 1,
            });
          }
        } else {
          this.createAlertForm.patchValue({
            timeframe: '',
          });
        }
      }

      if (changes?.minimumCount) {
        if (!isNaN(Number(changes.minimumCount))) {
          if (changes.minimumCount < 1) {
            this.createAlertForm.patchValue({
              minimumCount: 1,
            });
          }
        } else {
          this.createAlertForm.patchValue({
            minimumCount: '',
          });
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.document.body.classList.add('panel');
  }

  isFieldValid(field: string) {
    return (
      (!this.createAlertForm.get(field).valid &&
        this.createAlertForm.get(field).touched) ||
      (this.createAlertForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  isFormValid(): boolean {
    const location = this.modal.context.data.location;

    // Reset validators for all controls initially
    this.createAlertForm.controls['alertScenario'].setValidators(
      Validators.required
    );
    this.createAlertForm.controls['timeframe'].setValidators(
      Validators.required
    );
    this.createAlertForm.controls['minimumCount'].setValidators(
      Validators.required
    );
    this.createAlertForm.controls['description'].setValidators(
      Validators.required
    );

    if (location !== 'all-users') {
      this.createAlertForm.controls['variableSelected'].setValidators(
        Validators.required
      );
      this.createAlertForm.controls['variableInput'].setValidators(
        Validators.required
      );
    } else {
      this.createAlertForm.controls['variableSelected'].clearValidators();
      this.createAlertForm.controls['variableInput'].clearValidators();
    }
    Object.values(this.createAlertForm.controls).forEach((control) =>
      control.updateValueAndValidity()
    );

    return this.createAlertForm.valid;
  }

  nullify() {
    this.error = null;
    this.success = null;
  }

  saving = false;
  save() {
    this.saving = true;

    if (this.createAlertForm.valid) {
      let body = {
        alertScenarioId: this.createAlertForm.value.alertScenario,
        description: this.createAlertForm.value.description,
        configuration: JSON.stringify({
          variable: this.createAlertForm.value.variableSelected,
          timeframe: this.createAlertForm.value.timeframe,
          minimumCount: this.createAlertForm.value.minimumCount,
          notificationSettings: [
            ...(this.createAlertForm.get('slack')?.value || []),
            ...(this.createAlertForm.get('email')?.value || []),
          ],
        }),
      };
      if (this.modal.context.data.location !== 'all-users') {
        body.configuration = JSON.stringify({
          variable: this.createAlertForm.value.variableSelected,
          timeframe: this.createAlertForm.value.timeframe,
          minimumCount: this.createAlertForm.value.minimumCount,
          notificationSettings: [
            ...(this.createAlertForm.get('slack')?.value || []),
            ...(this.createAlertForm.get('email')?.value || []),
          ],
        });
      }
      if (this.modal.context.data.location == 'all-users') {
        body.configuration = JSON.stringify({
          variable: this.createAlertForm.value.variableInput,
          timeframe: this.createAlertForm.value.timeframe,
          minimumCount: this.createAlertForm.value.minimumCount,
          notificationSettings: [
            ...(this.createAlertForm.get('slack')?.value || []),
            ...(this.createAlertForm.get('email')?.value || []),
          ],
        });
      }
      // console.log(body);

      if (this.modal.context.data?.operation === 'edit') {
        this.alertSvc
          .editAlert(this.modal.context.data.alertId, body)
          .subscribe(
            (res) => {
              this.success = 'Alert edited Successfully';
              this.saving = false;
              setTimeout(() => {
                this.modal.approve(undefined);
              }, 1500);
            },
            (error) => {
              this.error = this.extractErrorMessage(error);
              this.saving = false;
            }
          );
      } else {
        this.alertSvc.createAlert(body).subscribe(
          (res) => {
            this.success = 'Alert Added Successfully';
            this.saving = false;
            setTimeout(() => {
              this.modal.approve(undefined);
            }, 1500);
          },
          (error) => {
            this.error = this.extractErrorMessage(error);
            this.saving = false;
          }
        );
      }
    } else {
      this.saving = false;
    }
  }

  // Helper method to extract error message
  private extractErrorMessage(error: any): string {
    return (
      error.error.errorMessage ||
      error.error.error ||
      error.error ||
      error.message ||
      error
    );
  }

  enableOnSave(item) {}

  scenariosLoading = false;
  getAlertScenarios() {
    this.scenariosLoading = true;
    this.alertSvc.getAlertScenarios(this.filter).subscribe(
      (res: any) => {
        this.scenariosLoading = false;
        this.alertScenarios = res.rows;

        if (this.modal.context.data?.operation === 'edit') {
          this.createAlertForm.patchValue({
            alertScenario: this.modal.context.data?.alertScenarioId,
          });
        }

        if (
          this.modal.context.data?.pageType &&
          this.modal.context.data?.pageType === 'Event Log'
        ) {
          let log = this.modal.context.data.log;
          this.configureAlertScenarioFromEventType(
            this.modal.context.data.log.eventType
          );

          if (
            this.modal.context.data.log.eventType === 'IP_ADDRESS' ||
            JSON.parse(log.metaData).ipAddress
          ) {
            this.createAlertForm.patchValue({
              variableSelected: JSON.parse(log.metaData)?.ipAddress,
            });
          }
        }
      },
      (error) => {
        this.scenariosLoading = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error.message
          ? error.message
          : error;
      }
    );
  }
  channels: [];

  allUsersFilter = new AppFilter({ rows: 1000000, _search: false });
  usersLoading = false;

  getUsersOnEservices() {
    this.usersLoading = true;
    this.alertSvc.getUsersOnEservices(this.allUsersFilter).subscribe(
      (res: any) => {
        this.users = res.rows.map((user) => {
          return {
            id: user.user.appUserId,
            name: `${user.user.firstName ? user.user.firstName : '--'}  ${
              user.user.lastName ? user.user.lastName : '--'
            }`,
          };
        });

        //remove duplicates, id duplicates
        this.users = Array.from(
          new Map(this.users.map((user) => [user.id, user])).values()
        );

        if (this.modal.context.data?.operation === 'edit') {
          this.createAlertForm.patchValue({
            variableSelected: JSON.parse(this.modal.context.data?.configuration)
              .variable,
          });
        } else if (
          this.modal.context.data?.log?.eventType === 'LOGIN_ATTEMPT'
        ) {
          let log = this.modal.context.data.log;
          this.createAlertForm.patchValue({
            variableSelected: JSON.parse(log.metaData)?.appUserId,
          });
        }

        this.usersLoading = false;
      },
      (error) => {
        this.usersLoading = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error.message
          ? error.message
          : error;
        this.usersLoading = false;
      }
    );
  }
  channelMap: { [key: string]: string } = {};
  notificationPreferences: any[] = [];
  slackPreferences: any[] = [];
  emailPreferences: any[] = [];
  notificationPreferencesLoading = false;

  prepareChannelMap() {
    setTimeout(() => {
      this.channels.forEach((channel: any) => {
        this.channelMap[channel.id] = channel.name;
      });
    }, 2000);
  }

  channelLoading: boolean;
  getChannel(page: number) {
    this.channelLoading = true;
    const filter = new AppFilter();
    filter.page = page;

    this.notificationSvc.getSlackChannel({ params: filter }).subscribe({
      next: (res: any) => {
        this.channelLoading = false;
        this.channels = res;
        this.prepareChannelMap(); // Optionally, you can call this here as well
      },
      error: (error) => {
        this.channelLoading = false;
        this.error = error.errorMessage ? error.errorMessage : error;
      },
    });
  }

  getNotificationPreferences() {
    this.notificationPreferencesLoading = true;
    this.alertSvc
      .getNotificationPreferences(this.notificationPreferencesFilter)
      .subscribe(
        (res: any) => {
          this.notificationPreferences = res.rows.map(
            (notificationPreference) => {
              let parsedPreference = JSON.parse(
                notificationPreference.settings
              );
              if (parsedPreference.notificationType === 'email') {
                this.emailPreferences.push({
                  settingId: notificationPreference.settingId,
                  ...parsedPreference,
                });
              } else if (parsedPreference.notificationType === 'slack') {
                this.slackPreferences.push({
                  settingId: notificationPreference.settingId,
                  ...parsedPreference,
                });
              }
              return {
                settingId: notificationPreference.settingId,
                ...parsedPreference,
              };
            }
          );
          if (this.modal.context.data?.operation === 'edit') {
            if (this.modal.context.data.email.length) {
              this.notificationPreferenceClick(null, 'email');
              this.modal.context.data.email.map((item) => {
                this.notificationPreferenceChildClick('email', item.settingId);
              });
              this.emailPreferences = this.emailPreferences.map(
                (emailPreference) => {
                  for (
                    let i = 0;
                    i < this.modal.context.data.email.length;
                    i++
                  ) {
                    if (
                      emailPreference.settingId ===
                      this.modal.context.data.email[i].settingId
                    ) {
                      return {
                        ...emailPreference,
                        checked: true,
                      };
                    }
                  }
                  return emailPreference;
                }
              );
            }
            if (this.modal.context.data.slack.length) {
              this.notificationPreferenceClick(null, 'slack');
              this.modal.context.data.slack.map((item) => {
                this.notificationPreferenceChildClick('slack', item.settingId);
              });

              this.slackPreferences = this.slackPreferences.map(
                (slackPreference) => {
                  for (
                    let i = 0;
                    i < this.modal.context.data.slack.length;
                    i++
                  ) {
                    if (
                      slackPreference.settingId ===
                      this.modal.context.data.slack[i].settingId
                    ) {
                      return {
                        ...slackPreference,
                        checked: true,
                      };
                    }
                  }
                  return slackPreference;
                }
              );
            }
          }
          this.notificationPreferencesLoading = false;
        },
        (error) => {
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error.message
            ? error.message
            : error;
          this.notificationPreferencesLoading = false;
        }
      );
  }

  configureAlertScenarioFromEventType(eventType: string) {
    // Get the appropriate alertScenarioId based on eventType
    const alertScenarioId = this.getAlertScenarioIdForEvent(eventType);

    if (alertScenarioId) {
      // Patch the form with the corresponding alertScenarioId
      this.createAlertForm.patchValue({
        alertScenario: alertScenarioId,
      });
    }
  }

  getAlertScenarioIdForEvent(eventType: string): string | undefined {
    switch (eventType) {
      case 'IP_ADDRESS':
        return 'blocked_ip_address';
      case 'FILE_UPLOAD':
        return 'abnormal_file_upload';
      case 'GEO_FENCE':
        return 'geofence_violations';
      case 'LOGIN_ATTEMPT':
        return 'failed_login_attempts';
      case 'RATE_LIMIT':
        return 'rate_limit_exceeded';
      case 'MALICIOUS_REQUEST':
        return 'malicious_requests';
      default:
        return undefined;
    }
  }
}

export class CreateAlertModal extends ComponentModalConfig<
  ICreateAlertModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Tiny) {
    super(CreateAlertModalComponent, {
      title,
      data,
    });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
